import React from "react";
import FindingResourcesCountKPI, {
  type FindingResourcesCountKPIProps,
} from "./FindingResourcesCountKPI";

type HighFindingResourcesKPIProps = Pick<
  FindingResourcesCountKPIProps,
  "selectedScope" | "filterToExecute" | "scopeToExecute" | "setIsReadyToExport"
>;

const HighFindingResourcesKPI: React.FC<HighFindingResourcesKPIProps> = ({
  selectedScope,
  filterToExecute,
  scopeToExecute,
  setIsReadyToExport = null,
}) => {
  const filterFieldsToOverride = JSON?.stringify({
    value: ["2"],
    field: "remediation_item.severity",
    condition: "in",
  });

  return (
    <FindingResourcesCountKPI
      scopeToExecute={scopeToExecute}
      selectedScope={selectedScope}
      filterToExecute={filterToExecute}
      filterFieldsToOverride={filterFieldsToOverride}
      severity={2}
      setIsReadyToExport={setIsReadyToExport}
    />
  );
};

export default HighFindingResourcesKPI;
